export enum RamCalculationErrorCode {
  SyntaxError = -1,
  ImportError = -2,
  URLImportError = -3,
}
